import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Agents from './LandingPages/Agents/Agents';
import AgentsPricing from './LandingPages/Agents/AgentsPricing/AgentsPricing';
import AgentsDocs from './LandingPages/Agents/AgentsDocs/AgentsDocs';
import AgentsPrivacy from './LandingPages/Agents/AgentsPrivacy/AgentsPrivacy';
import Home from './LandingPages/Home/Home';
import Attribution from './LandingPages/Attribution/Attribution';
import GA4 from './LandingPages/GA4/GA4';
import BusinessIntelligence from './LandingPages/BusinessIntelligence/BusinessIntelligence';


function App() {
  return (
    <Router>
      <Routes>
        <Route key='home' path='/' element={<Home/>} exact={true} />
        <Route key='agents' path='/agents' element={<Agents/>} />
        <Route key='agents_pricing' path='/agents_pricing' element={<AgentsPricing/>} />
        <Route key='agents_docs' path='/agents_docs' element={<AgentsDocs/>} />
        <Route key='privacy' path='/privacy' element={<AgentsPrivacy/>} />
        <Route key='attribution' path='/attribution' element={<Attribution/>} />
        <Route key='ga4' path='/ga4' element={<GA4/>} />
        <Route key='bi' path='/bi' element={<BusinessIntelligence/>} />
      </Routes>
    </Router>
  );
}

export default App;
